<template>
    <div class="p20" v-loading.body="loading">
        <!-- 头部按钮部分 start -->
        <div class="el-row ly-bill-title">
            <el-col :span="12">
                <h1 style="padding-top:5px;">修改三包登记单</h1>
            </el-col>
            <el-col :span="12" class="tr">
                <el-button type="primary"
                    :disabled="submitForm.status == 11 ? true : false" 
                    @click="submit" size="small" :loading="submitLoad">
                    <i class="fa fa-save" v-if="!submitLoad"></i>&nbsp;提交
                </el-button>
                <ly-router-button size="small">
                    <i class="fa fa-chevron-left"></i>&nbsp;返回
                </ly-router-button>
            </el-col>
        </div>
        <!-- 头部按钮部分 end -->
        <!-- 表单列表 start -->
        <el-card class="box-card mt15">
            <Ly-search-form 
                :config="formConfig" 
                :rules="formRules"
                :is-search="false"
                label-width="120px"
                ref="searchForm">
            </Ly-search-form>
        </el-card>
        <!-- 表单列表 end -->
        <!-- 商品选择组件 start -->
        <el-card class="box-card mt15" ref="productCard" v-if="!loading"> 
            <ly-product-table 
                ref="productTable"
                v-model="submitForm.productList"
                :thead-config="productConfig">
            </ly-product-table>
        </el-card>
        <!-- 商品选择组件 end -->
    </div>
</template>
<script>
    /**
     * 三包登记的修改页面
     * @author zjs
     * @time 2017-09-18
     */
    import AddEditConfig from './edit-form'
    import AddProductConfig from './add-product'
    import LySearchForm from '@c/search-form'
    import LyProductTable from '@c/product-table'
    import LyRouterButton from '@c/router-button'
    import AddRulesConfig from './rules'
    export default {
        mixins: [
            AddEditConfig, 
            AddProductConfig,
            AddRulesConfig
        ],
        components: {
            LySearchForm,
            LyProductTable,
            LyRouterButton
        },
        data () {
            return {
                loading: true,
                submitLoad: false, // 提交按钮的状态标识
                infoId: 0, // 详情的ID
                submitForm: {} // 详情的数据
            }
        },
        created () {
            this.init()
        },
        watch: {
            '$route' (to, from) {
                // 路由变化时，更新配置
                if (to.name === 'CheckinEdit') {
                    this.init()
                }
            }
        },
        methods: {
            init () {
                // 获取详情的ID
                this.infoId = this.$route.params.id
                if (this.infoId) {
                    this.queryEditData()
                } else {
                    this.$message({
                        message: '无ID',
                        type: 'warning'
                    })
                }
            },
            /**
             * 获取要修改的数据
             */
            queryEditData () {
                this.$api.queryArr(['api/sanbaoDj', 'edit'], null, [this.infoId]).then((rs) => {
                    this.submitForm = rs
                    // 设置表单中的回填数据
                    this.$refs['searchForm'].initBindFormData(rs)
                    // 设置UUID
                    this.submitForm.uuid = this.$utils.createUUID()
                    // 取消加载
                    setTimeout(() => {
                        this.loading = false
                    }, 100)
                }).catch((error) => {
                    // 取消加载
                    this.loading = false
                    this.$message({
                        message: error,
                        type: 'warning'
                    })
                })
            },
            submit () {
                if (this.$refs['searchForm'].validateForm()) {
                    if (this.submitForm.productList && this.submitForm.productList.length > 0) {
                        // 货品验证
                        let productMsg = this.validateProduct(this.submitForm.productList)
                        // 货品验证不通过的情况
                        if (productMsg.length > 0) {
                            this.$alert(productMsg, '货品录入提示', {
                                confirmButtonText: '确定'
                            })
                        } else {
                            this.submitLoad = true
                            // 获得得查询的字段
                            this.submitForm = Object.assign(this.submitForm, this.$refs['searchForm'].bindForm)
                            // 提交数据
                            this.$api.save('api/sanbaoDj/' + this.infoId,this.submitForm).then((rs) => {
                                this.$alert('数据提交成功', '修改', {
                                    confirmButtonText: '确定',
                                    callback: action => {
                                        this.submitLoad = false
                                        // 跳转到详情页面
                                        this.$router.push('/bill/checkin/info/' + this.infoId)
                                    }
                                });
                                // 更新UUID
                                this.submitForm.uuid = this.$utils.createUUID()
                            }).catch((error) => {
                                this.submitLoad = false
                                this.$message({
                                    message: error,
                                    type: 'warning'
                                })
                            })
                        }
                    } else {
                        this.$message({
                            message: '请添加货品',
                            type: 'warning'
                        })
                    }
                } else {
                    this.$message({
                        message: '请将信息填写完整',
                        type: 'warning'
                    })
                }
            }
        }
    }
</script>